export default __webpack_public_path__ + "static/The Home_Image 7_carousel 4@2x-f2e2ffb6d13d4f14b4d8baa2305d6a21.jpg";